// Access identifiers are account configuration, not legacy supplier database IDs.
export function connectionAccessCodes(value: string): string[] {
  return [
    ...new Set(
      value
        .split(',')
        .map((code) => code.trim())
        .filter(Boolean),
    ),
  ];
}
export function validConnectionAccess(value: string): boolean {
  const codes = connectionAccessCodes(value);
  return (
    codes.length > 0 &&
    codes.length <= 50 &&
    codes.every(
      (code) => code.length <= 256 && !/[\s/\\?#%\u0000-\u001f\u007f]/.test(code) && code !== '.' && code !== '..',
    )
  );
}
